<template>
    <section class="container">
        <div class="row">
            <div class="col-md-12 col-lg-8">
                <div
                    v-if="carsForCityAndAddress.length === 0"
                    class="alert alert-warning alert_cutting d-flex align-items-center justify-content-between flex-wrap flex-md-nowrap px-md-4 mt-3"
                    role="alert"
                >
                    <div class="mb-2 mb-md-0 fw-medium">
                        {{ deliveryCallToActionText }}
                    </div>
                    <a href="/metalloprokat/" class="btn btn-primary">К покупкам</a>
                </div>

                <h2 class="mt-40">Расчет стоимости доставки</h2>
                <div class="content-block delivery-address delivery-address--gray">
                    <div class="delivery-address__form">
                        <div class="delivery-address__place">
                            <div class="delivery-place">
                                <strong class="delivery-place__title">Ваш город отгрузки</strong>
                                <shipment-cities
                                    @shipment-city-selected="onShipmentCitySelected"
                                    :selected-city="shipmentCity.CITY_NAME"
                                />

                            </div>
                        </div>
                        <label class="form-label">Введите адрес доставки *</label>
                        <div class="mb-3">
                            <address-input
                                v-if="isNewDeliveryCalculator"
                                placeholder="Населенный пункт, улица, дом"
                                :value="deliveryAddressModel"
                                className="pr-8"
                                @input="onAddressSelect"
                            />
                            <address-input-yandex
                                v-else
                                :bounds="boundsPoint"
                                :is-operator="isOperator"
                                :is-need-geocode="isNeedGeocode"
                                placeholder="Населенный пункт, улица, дом"
                                :value="deliveryAddressModel"
                                className="pr-8"
                                @change="onAddressSelect"
                                :is-disabled="isDisabled"
                                :deliveryCalculator1C="deliveryCalculator1C"
                            />
                        </div>
                    </div>
                    <span
                        class="link-button"
                        data-bs-toggle="modal"
                        data-bs-target="#mapPopupModal"
                        @click="setPlacemark"
                    >
                        <i class="icn-map"></i>
                        <span>Указать на карте</span>
                    </span>
                    <div class="modal fade" id="mapPopupModal" tabindex="-1" aria-hidden="true" ref="mapPopupModal">
                        <map-popup
                            ref="mapPopup"
                            v-model="deliveryAddressModel"
                            :initial-coords="$root.JS_DATA.CURRENT_CITY_COORDS"
                            :polygons="$root.JS_DATA.DELIVERY_POLYGONS"
                            :promo-polygon="$root.JS_DATA.PROMO_POLYGON.UF_POLYGON_POINTS"
                            :shipment-city="shipmentCity"
                            :curentRegionUid="currentRegionUid"
                            :deliveryCalculator1C="deliveryCalculator1C"
                        />
                    </div>

                    <bx-evraz-vue-order-elements-warehousedistance
                        v-if="distanceToWarehouse"
                        :sYandexDeliveryDistance="distanceToWarehouse"
                    />
                </div>
                <div
                    v-if="carsForCityAndAddress.length > 0"
                    class="alert alert-warning alert_cutting d-flex align-items-center justify-content-between flex-wrap flex-md-nowrap px-md-4 mt-3"
                    role="alert"
                >
                    <div class="mb-2 mb-md-0 fw-medium">
                        {{ deliveryCallToActionText }}
                    </div>
                    <a href="/metalloprokat/" class="btn btn-primary">К покупкам</a>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import ShipmentCities from "./ui/ShipmentCities.vue";

/**
 * Компонент для выбора города отгрузки, адреса доставки
 * @emits address-selected - выбран адрес из списка
 * @emits address-changed - любые изменения в адресе
 */
export default {
    name: "DeliveryPicker",

    props: {
        bounds: {
            type: Array,
            required: true,
        },
        currentRegionUid: {
            type: String,
            required: true,
        },
        deliveryCalculator1C: {
            type: Boolean,
            required: true,
        },
        isDisabled: {
            type: Boolean,
            required: true,
        },
        isNeedGeocode: {
            type: Boolean,
            required: true,
        },
        isOperator: {
            type: Boolean,
            required: true,
        },
        shipmentCity: {
            type: Object,
            required: true,
        },
        deliveryCallToActionText: {
            type: String,
            required: true
        },
        distanceToWarehouse: {
            type: String,
            required: true
        },
        carsForCityAndAddress: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            /** Адрес доставки (объект с полями addressText, data)
             * Из data используются .city, .coords */
            deliveryAddress: {},
            boundsPoint: this.bounds,
            isNewDeliveryCalculator: BX.Evraz.isNewDeliveryCalculator
        };
    },

    mounted() {
        this.$refs.mapPopupModal.addEventListener("shown.bs.modal", () => {
            this.$refs.mapPopup.fitMapToViewport();
        });
        this.$refs.mapPopupModal.addEventListener("hide.bs.modal", () => {
            this.$refs.mapPopup.onCancel();
        });
    },

    computed: {
        deliveryAddressModel: {
            get() {
                return this.deliveryAddress;
            },
            set(value) {
                this.deliveryAddress = value;
                //this.distanceToWarehouse = ""; // Очистить дистанцию От склада
                if (value && value.data != null) {
                    this.$emit("address-selected", value);
                }
                this.$emit("address-changed", value);
            },
        },
    },

    methods: {
        onAddressSelect(address) {
            this.deliveryAddressModel = address;
        },

        /** Подсказки для поиска */
        async querySuggestions(inputText) {
            return await BX.Evraz.deliveryApi.querySuggestions(inputText);
        },

        /** Выбран город отгрузки */
        onShipmentCitySelected(city) {
            this.$emit("shipment-city-selected", city);
            if (city.LAT && city.LON) {
                this.boundsPoint = [
                    [city.LAT, city.LON],
                    [city.LAT, city.LON],
                ];
            }
        },

        /* добавляет маркер на карту при открытии, если он не был добавлен */
        setPlacemark() {
            if (
                this.deliveryAddressModel &&
                this.deliveryAddressModel.addressText &&
                localStorage.getItem("isNeedSetPlacemark")
            ) {
                localStorage.removeItem("isNeedSetPlacemark");
                BX.Evraz.getCoordsByAddress(
                    this.deliveryAddressModel.addressText,
                    this,
                    callbackSuccess,
                    callbackError
                );
                function callbackSuccess(response) {
                    var coords = response.data.response.GeoObjectCollection.featureMember[0].GeoObject.Point.pos
                        .split(" ")
                        .reverse();
                    let yandexMap = this.$refs.mapPopup.$refs.yandexMap;
                    yandexMap.yaMap.setCenter(coords, yandexMap.yaMap.getZoom(), { duration: 300 });
                    yandexMap.setPlacemark(coords);
                }
                function callbackError(err) {
                    console.log(err);
                }
            }
        },
    },
    components: { ShipmentCities },
};
document.addEventListener("DOMContentLoaded", function () {
    var currentCity = document.querySelector('[data-bs-target="#modal-shipment-cities"]');
    window.defaultCity = currentCity.innerText;

    function sendToGa(eventAction, eventLabel) {
        gaPush.sendToGA("GAevent", "delivery", eventAction, eventLabel, {
            dimension7: window.dimension7,
            dimension11: window.defaultCity,
        });
    }

    if (currentCity) {
        currentCity.addEventListener("click", function (e) {
            sendToGa("click", window.defaultCity);
        });

        if (document.querySelector("#mapPopupModal")) {
            document.querySelector("#mapPopupModal").addEventListener("shown.bs.modal", function () {
                sendToGa("inputAddressMap", currentCity.innerText);
            });
        }

        var modalCities = document.querySelector("#modal-shipment-cities");
        if (modalCities) {
            modalCities.addEventListener("shown.bs.modal", function () {
                sendToGa("changeGeoShow", currentCity.innerText);
            });
            modalCities.addEventListener("click", function () {
                sendToGa("changeGeoCloseAnother", currentCity.innerText);
            });
            document.querySelector("#modal-shipment-cities .modal-dialog").addEventListener("click", function (e) {
                e.stopPropagation();
            });
            document.querySelector("#modal-shipment-cities .modal-close").addEventListener("click", function () {
                sendToGa("changeGeoClose", currentCity.innerText);
            });
        }
    }
});
</script>

<style scoped>
.link-button {
    cursor: pointer;
}

.delivery-place__city span {
    cursor: pointer;
}

strong.delivery-place__title {
    font-weight: 500;
}

@media (max-width: 425px) {
    .alert_cutting .btn {
        width: 100%;
    }
}
</style>
